import { debounce } from "lodash";

window.pingInit.initializeSelectRemoveAll = (rootElement) => {
  rootElement.querySelectorAll('.facets-bulk-actions__select-all').forEach(selectAll => {
    selectAll.addEventListener('click', () => {
      selectAll.closest('.js-filter').querySelectorAll('.facets__element:not(.hidden) input:not(:checked) + label').forEach(label => {
        label.click();
      });
    });
  });

  rootElement.querySelectorAll('.facets-bulk-actions__remove-all').forEach(removeAll => {
    removeAll.addEventListener('click', () => {
      removeAll.closest('.js-filter').querySelectorAll('.facets__element:not(.hidden) input:checked + label').forEach(label => {
        label.click();
      });
    });
  });
};

window.pingInit.searchFilter = (value, wrapper) => {
  wrapper.querySelectorAll('.facets__element').forEach(element => {
    const labelValue = element.querySelector('label').innerText.toLowerCase();
    if (value.toLowerCase()) {
      if (labelValue.indexOf(value.toLowerCase()) < 0) {
        element.classList.add('hidden');
      } else {
        element.classList.remove('hidden');
      }
    } else {
      element.classList.remove('hidden');
    }
  });

  const hiddenFields = wrapper.querySelectorAll('.facets__element:not(.hidden)').length;
  const noResultsLabel = wrapper.querySelector('.facets__no-results');
  if (hiddenFields == 0) {
    noResultsLabel.classList.remove('hidden');
  } else {
    noResultsLabel.classList.add('hidden');
  }
};

window.pingInit.addSearchEvents = (wrapper) => {
  const input = wrapper.querySelector('input[type="text"]');
  const searchIcon = wrapper.querySelector('.facets-search__btn--search');
  const closeIcon = wrapper.querySelector('.facets-search__btn--close');
  if (input && searchIcon && closeIcon) {
    searchIcon.addEventListener('click', () => { input.focus(); });
    closeIcon.addEventListener('click', () => {
      input.value = '';
      window.pingInit.searchFilter(input.value, wrapper.closest('.js-filter'));
    });
  }
};


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce(e => {
      this.onSubmitHandler(e);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    document.querySelectorAll('.collection-main-filters__active-filter[data-for]').forEach(activeFilter => {
      activeFilter.addEventListener('click', () => {
        const label = document.querySelector(`#FacetFiltersForm #${activeFilter.dataset.for} + label`);
        if (label) {
          label.click();
        }
      });
    });
    document.querySelectorAll('.js-filter .facets__search').forEach(searchWrapper => {
      window.pingInit.addSearchEvents(searchWrapper);
    });
    window.pingInit.initializeSelectRemoveAll(this);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    document.getElementById('ProductGridContainer').classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = element => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl) ?
      FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.completeRenderPage();
      })
      .catch(e => {
        console.error(e);
        FacetFiltersForm.completeRenderPage();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.completeRenderPage();
  }

  static completeRenderPage() {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.classList.remove('loading');

    if (window.pingInit.initProductTiles) window.pingInit.initProductTiles(gridContainer);
    if (window.pingInit.proxyLinkSetup) window.pingInit.proxyLinkSetup(gridContainer);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      callback: function (requestURL) {
        window.pingInit.ajaxinateCallBack(requestURL);
      }
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const activeFiltersContainer = document.querySelector('.collection-main-filters__active-filters-wrapper');
    if (activeFiltersContainer) {
      activeFiltersContainer.innerHTML = '';
    }

    facetDetailsElements.forEach((element) => {
      const filterWrapper = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      const searchInput = filterWrapper.querySelector('.facets__search input');
      filterWrapper.innerHTML = element.innerHTML;
      if (searchInput) {
        filterWrapper.querySelector('.facets__search input').value = searchInput.value;
        window.pingInit.searchFilter(searchInput.value, filterWrapper);
        window.pingInit.addSearchEvents(filterWrapper.querySelector('.facets__search'));
      }
      if (activeFiltersContainer && !element.classList.contains('facets__section--availability')) {
        filterWrapper.querySelectorAll('.facets__element input:checked + label').forEach(activeFilter => {
          const newElement = document.createElement('span');
          newElement.classList.add('collection-main-filters__active-filter');
          newElement.innerHTML = `${activeFilter.innerHTML}`;
          newElement.addEventListener('click', () => {
            const label = document.querySelector(`#FacetFiltersForm [id="${activeFilter.getAttribute('for')}"] + label`);
            if (label) {
              label.click();
            }
          });
          activeFiltersContainer.appendChild(newElement);
        });
      }
    });

    const activeLabel = document.querySelector('.collection-main-filters__values-counter');
    if (activeLabel) {
      const activeCounter = document.querySelectorAll('.js-filter:not(.hidden) input:checked').length;
      activeLabel.innerHTML = `(${activeCounter} ${activeCounter > 1 ? activeLabel.dataset.multipleLabel : activeLabel.dataset.singleLabel})`;
      if (activeCounter > 0) {
        activeLabel.classList.remove('hidden');
      } else {
        activeLabel.classList.add('hidden');
      }
    }

    window.pingInit.initAccordions('.facets__accordions details:not(.facets__section--sorting)');
    window.pingInit.initializeSelectRemoveAll(document.querySelector('facet-filters-form'));
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (event.target?.type === 'text') {
      const filterWrapper = event.target.closest('.js-filter');
      window.pingInit.searchFilter(event.target.value, filterWrapper);
    } else {
      const availbleCheckbox = this.querySelector('.facets__section--availability input[type="checkbox"][value="1"]');
      if (availbleCheckbox) {
        if (this.querySelectorAll('.facets__section:not(.facets__section--availability) input[type="checkbox"]:checked').length > 0) {
          availbleCheckbox.checked = true;
        } else {
          availbleCheckbox.checked = false;
        }
      }
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);
